import { Component, ContentChild, TemplateRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, map } from 'rxjs';
import { PoolerType } from 'server/shared/models/poolerType';
import { CustomerService } from '../../services/customer.service';

@Component({
  selector: 'app-pooler-type-select',
  templateUrl: './pooler-type-select.component.html',
  styleUrls: ['./pooler-type-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PoolerTypeSelectComponent,
      multi: true,
    },
  ],
})
export class PoolerTypeSelectComponent implements ControlValueAccessor {
  customerPoolerTypes$: Observable<PoolerType[]>;

  isDisabled = false;
  selectedValue?: string;

  @ContentChild('hint') hintContent?: TemplateRef<any>;

  onChange: any = (poolerTypeId: string) => {};
  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  onTouch: any = () => {};
  registerOnTouched(onTouched: Function) {
    this.onTouch = onTouched;
  }

  constructor(private customerService: CustomerService) {
    this.customerPoolerTypes$ = this.customerService.readyDispoCustomer$.pipe(
      map((customer) => customer?.poolerTypes || []),
    );
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }

  writeValue(value: string) {
    this.selectedValue = value;
  }

  selectionChanged(poolerTypeId: string) {
    this.selectedValue = poolerTypeId;
    this.onChange(poolerTypeId);
  }
}
